import { useState, useEffect } from 'react';
import { matchRoutes, useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { GridValueGetterParams } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import get from 'lodash/get';
import { Stack, Tabs, Tab, Tooltip, Box } from '@mui/material';
import Chip from '@mui/material/Chip';
import { factoryDefaultFields, factoryMetaDataSchema, factorySchema, factoryUISchema } from './form';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import MasterComponent from '../../common/MasterComponent';
import FactoryUseCaseFormModal from '../../common/factoryUseCaseFormModal';
import PopUp from '../../components/Popup';
import { factoryManagementActions } from '../../store/reducers/factory-management';
import Snackbar from '../../common/snackBar';
import { sentenceCase } from 'change-case';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import { ReactComponent as SuccessIcon } from '../../assets/icons/main/successIcon.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/main/info-icon.svg';
import { notificationActions } from '../../store/reducers/notification';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { FactoryDataRequestPayloadTypes } from '../../store/models/factory-management';
import { ComponentDataRequestPayloadTypes } from '../../store/models/component-master';
import { isEmpty } from 'lodash';
import { gatewayMasterActions } from '../../store/reducers/gateway-master';
// import { routePaths } from '../../utils/route-paths';
import {palette} from '../../theme/palette';
import { useTheme } from '@mui/material';
import FactoryDownloadTemplateModal from '../../common/FactoryDownloadTemplateModal';
import { componentMasterActions } from '../../store/reducers/component-master';
import { generateAndDownloadProtocolSheetExcelTemplate } from '../../utils/excelHelperProtocolRows';
import { secretManagerActions } from '../../store/reducers/secret-manager';

const Styles = {
  displayName: {
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: '1rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  cursorPointer: { cursor: 'pointer' },
};

const FactoryList = ({
  ontologyData,
  factoriesList,
  factoriesListTotalRowCount,
  factoriesListPageNumber,
  isFactoriesListLoading,
  isAddFactorySuccess,
  isUpdateFactorySuccess,
  isRemoveFactorySuccess,
  ontologyMgmntData,
  selectedTab,
  onTabChange,
  isupdateFactoryStatusError,
  isUpdateFactoryStatusSuccess,
  approver,
  filterStatus,
  searchItem,
  settingsData,
  componentMasterData,
  gateways,
  secretsData,
}: any) => {
   const routePaths: any = get(useOutletContext(), 'combinedRoutePaths', [])
  var pluralize = require('pluralize');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [factoryData, setFactoryData] = useState<any>(factoryDefaultFields);
  const [factoryManagementData, setFactoryManagementData] = useState<any>([]);
  const [factoryTags, setFactoryTags] = useState<any[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [alertPopup, setAlertPopup] = useState<any>({ isOpen: false, type: '' });
  const [deletableFactory, setDeletableFactory] = useState<any>({});
  const [editOntoData, setEditOntoData] = useState<any>([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [hiddenColumns, setHiddenColumns] = useState<any>({});
  const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
  const [isDownloadTemplateModalOpen, setIsDownloadTemplateModalOpen] = useState(false);
  const [selectedTemplateComponents, setSelectedTemplateComponents] = useState<Record<string, boolean>>({});
  const [selectedImportGatewayId, setSelectedImportGatewayId] = useState<string>('');
  const [selectedImportFile, setSelectedImportFile] = useState<File | null>(null);

  const outletData : any = get(useOutletContext(),'outletData',{});
  const themeData : any = useTheme();
  const location = useLocation();
  const [pageData, setPageData] = useState<any>({})

  let matchedRoute: any = matchRoutes(routePaths, location);
  matchedRoute = !isEmpty(matchedRoute) ? matchedRoute[0] : {};

  useEffect(() => {
    if (!isEmpty(outletData)) {
      if (!isEmpty(outletData[matchedRoute.route.endPointPath.replace('/', '_')])) {
        const pageData = { ...outletData[matchedRoute.route.endPointPath.replace('/', '_')], machine_name: get(outletData.things_machines, 'entity_name', 'Machine') }
        setPageData(pageData)
      } else {
        setPageData({ machine_name: get(outletData.things_machines, 'entity_name', 'Machine') })
      }
    }
  }, [outletData])

  const dispatchComponentListRequest = (payload: ComponentDataRequestPayloadTypes) => {
    dispatch(componentMasterActions.getServicesDataRequest({ ...payload }));
  };

  useEffect(() => {
    dispatchComponentListRequest({ limit: 1000, page: 1 });
    dispatch(gatewayMasterActions.getGatewayDataRequest());
    dispatch(secretManagerActions.getSecretsRequest({ limit: 1000, page: 1 }));

    return () => {
      dispatch(componentMasterActions.resetComponentMasterData());
    };
  }, [dispatch]);

  const dispatchFactoriesListRequest = (payload: FactoryDataRequestPayloadTypes) => {
    dispatch(factoryManagementActions.getFactoriesList({ ...sortingModel, search_item: searchItem, ...payload, pageName: get(pageData,'entity_name', factoryLabel) }));
  };

  useEffect(() => {
    dispatchFactoriesListRequest({
      limit: DEFAULT_PAGE_SIZE,
      page: DEFAULT_PAGE_NUMBER,
      filter_status: filterStatus,
    });
    dispatch(ontologyMasterActions.getOntologyList(''));
    dispatch(ontologyMasterActions.getOntologyMgmntList(''));
    // dispatch(factoryManagementActions.getFactoriesList());
    if (selectedTab === 1) {
      setHiddenColumns({ actions: false });
    } else {
      setHiddenColumns({});
    }

    return () => {
      dispatch(factoryManagementActions.resetLoadingState());
      dispatch(factoryManagementActions.resetFactoryData());
    };
  }, [selectedTab, pageData]);


  useEffect(() => {
    if (factoriesList && factoriesList.length > 0) {
      setFactoryManagementData(
        factoriesList.map((item: any) => {
          return {
            ...item,
            id: item.factory_id,
            factory_tags:
              item.factory_tags && item.factory_tags.length > 0
                ? item.factory_tags.map((val: any, index: any) => {
                  return { ...val, id: index + 1 };
                })
                : [],
          };
        })
      );
    } else {
      setFactoryManagementData([]);
    }

    // if (pathname.length) {
    //   const pathnamesTemp: any = pathname.split('/').filter(Boolean);
    //   if (pathnamesTemp.length) {
    //     const pathnamesData: any = pathnamesTemp.filter((i: any, index: number) => index > 0).map((item: any, index: number) => {
    //       return { route: pathnamesTemp[0] + '/' + pathnamesTemp[1], pathName: item, navigate: true }
    //     });
    //     dispatch(pageActions.setPagePath(pathnamesData));
    //   }
    // }
  }, [factoriesList]);

  useEffect(() => {
    // let alertType = '';
    // let isPopup = false;

    // if (isAddFactorySuccess) {
    //   alertType = 'add';
    //   isPopup = true;
    // } else if (isUpdateFactorySuccess) {
    //   alertType = 'update';
    //   isPopup = true;
    // } else if (isRemoveFactorySuccess) {
    //   alertType = 'deleteSuccess';
    //   isPopup = true;
    // }

    if (isAddFactorySuccess || isUpdateFactorySuccess || isRemoveFactorySuccess || isUpdateFactoryStatusSuccess) {
      setSelectedRows([]);
      dispatchFactoriesListRequest({
        limit: DEFAULT_PAGE_SIZE,
        page:
          isRemoveFactorySuccess && factoryManagementData.length === 1 && factoriesListPageNumber !== 1
            ? factoriesListPageNumber - 1
            : factoriesListPageNumber,
        filter_status: filterStatus,
      });
    }

    if (isupdateFactoryStatusError) {
      setSelectedRows([]);
    }
  }, [
    isAddFactorySuccess,
    isUpdateFactorySuccess,
    isRemoveFactorySuccess,
    dispatch,
    isupdateFactoryStatusError,
    isUpdateFactoryStatusSuccess,
  ]);

  const onModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setFactoryData(factoryDefaultFields);
    setFactoryTags([]);
    setSelectedImportGatewayId('');
    setSelectedImportFile(null);
  };

  const handleEdit = (row: any) => {
    let ontoId = row.onto_manage_id;
    if (ontologyMgmntData.length > 0) {
      let tempOntoData: any = [];
      restartTheLoop: while (true) {
        for (const item of ontologyMgmntData) {
          if (item.onto_manage_id == ontoId) {
            tempOntoData.unshift(item);
            ontoId = item.parent_id;
            continue restartTheLoop;
          }
        }
        break;
      }

      setEditOntoData(
        tempOntoData.map((item: any) => {
          let getLevelName = ontologyData.filter((data: any) => {
            return data.id === item.onto_level_number;
          })[0];
          return {
            ...item,
            level_name: getLevelName?.level_name || '',
          };
        })
      );
    }
    setIsEdit(true);
    setFactoryData(row);
    setFactoryTags(row.factory_tags.map((tag: any) => ({ ...tag, id: tag.tag_id })));
    setIsModalOpen(true);
  };

  const handleDelete = () => {
    dispatch(factoryManagementActions.removeFactoryRequest(get(deletableFactory, 'factory_id', '')));
    setDeletableFactory({});
    setAlertPopup({ isOpen: false, type: '' });
  };

  const onSave = (payload: any) => {
    if (isEdit) {
      dispatch(factoryManagementActions.updateFactoryRequest(payload));
    } else {
      dispatch(factoryManagementActions.addFactoryRequest(payload));
    }
  };

  const handleRowSelection = (params: any) => {
    setSelectedRows(params);
  };

  const onStatusChange = (statusType: string) => {
    if (selectedRows.length) {
      const payload: any = factoryManagementData
        .filter((item: any) => selectedRows.includes(item.factory_id))
        .map((item: any) => {
          if (statusType != '') {
            return { ...item, status: statusType };
          } else {
            return { ...item };
          }
        });
      dispatch(factoryManagementActions.updateFactoryStatusRequest(payload));
      dispatch(notificationActions.getNotificationDataRequest(''));
    } else {
      Snackbar.info('Please select factory.');
    }
  };

  const isRowSelectable = (params: any) => {
    return !['approved', 'rejected', 'deployed'].includes(params.row.status);
  };

  const renderAlertPopup = () => {
    const alertData = getAlertData[alertPopup.type];
    const isDelete = alertPopup.type === 'delete';

    const onClosePopup = () => {
      if (isDelete) {
        setDeletableFactory({});
      } else {
        setIsEdit(false);
        setFactoryData({});
        setFactoryTags([]);
      }
      setAlertPopup({ isOpen: false, type: '' });
    };

    return (
      <PopUp
        open={alertPopup.isOpen}
        icon={get(alertData, 'icon')}
        message={get(alertData, 'msg')}
        cancel={isDelete}
        confirmation={true}
        cancelLabel='No'
        confirmLabel={isDelete ? 'Yes' : 'Ok'}
        onConfirm={() => {
          if (isDelete) {
            handleDelete();
          } else {
            setAlertPopup({ isOpen: false, type: '' });
          }
        }}
        onClose={onClosePopup}
        onCancel={onClosePopup}
      />
    );
  };

  const onClickFactoryName = (row: any) => {
    // const factoryName = row.factory_name.split(' ').join('-').toLowerCase();
    const factoryId = String(row.id);
    navigate(`${'/assets/factory-management/' + factoryId}`);
  };

  const onTemplateComponentToggle = (component: string) => {
    setSelectedTemplateComponents((prevState) => {
      const updatedSelection = {
        ...prevState,
        [component]: !prevState[component],
      };

      const selectedComponents = Object.keys(updatedSelection).filter((key) => updatedSelection[key]);
      console.log('Selected template components:', selectedComponents);

      return updatedSelection;
    });
  };

  const onDownloadTemplate = () => {
    setIsDownloadTemplateModalOpen(true);
  };

  const onCloseDownloadTemplateModal = () => {
    setIsDownloadTemplateModalOpen(false);
    setSelectedTemplateComponents({});
  };

  const onDownloadTemplateConfirm = async (selectedComponentIds: string[]) => {
    if (!selectedComponentIds.length) {
      Snackbar.info('Please select at least one component.');
      return;
    }

    const secretOptions: string[] = Array.from(
      new Set(
        (secretsData || [])
          .map((secret: any) =>
            String(
              secret?.secret_name ??
                secret?.name ??
                secret?.secret_key ??
                secret?.key ??
                secret?.id ??
                ''
            ).trim()
          )
          .filter(Boolean)
      )
    );

    const selectedComponents = (componentMasterData || []).filter((component: any) =>
      selectedComponentIds.includes(String(component?.component_id))
    );

    for (const component of selectedComponents) {
      const componentName = String(component?.component_name ?? 'component').trim() || 'component';
      const safeComponentName = componentName.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

      await generateAndDownloadProtocolSheetExcelTemplate(component?.ui_schema, {
        fileName: `asset_template_${safeComponentName}`,
        maxParamsPerMessage: 3,
        excludedLabels: ['copy configuration'],
        dataSchema: component?.backend_schema,
        secretOptions,
        componentName,
      });
    }

    setIsDownloadTemplateModalOpen(false);
    setSelectedTemplateComponents({});
  };

  

  const factoryLabel = get(pageData, 'entity_name', ontologyData?.slice(-1)?.[0]?.level_name ?? 'Shop floor');

  const fatoryTitle = get(pageData, 'entity_name', factoryLabel).toUpperCase();

  const getAlertData: any = {
    add: {
      icon: <SuccessIcon  style={{ color: palette.success.dark }} />,
      msg: 'New ' + fatoryTitle + ' Added',
    },
    update: {
      icon: <SuccessIcon  style={{ color: palette.success.dark }}  />,
      msg: fatoryTitle + ' Edited Successfully!',
    },
    deleteSuccess: {
      icon: <SuccessIcon  style={{ color: palette.success.dark }}  />,
      msg: fatoryTitle + ' Deleted Successfully!',
    },
    delete: {
      icon: <AlertIcon style={{ color : palette.warning.main }}/>,
      msg: 'Are you sure to delete this ' + fatoryTitle + '?',
    },
  };

  const renderFormModal = () => (
    <FactoryUseCaseFormModal
      title={`${isEdit ? 'EDIT' : 'ADD NEW'} ${factoryLabel.toUpperCase()}`}
      isModalOpen={isModalOpen}
      data={factoryData}
      setData={setFactoryData}
      tags={factoryTags.map((item: any, index: any) => {
        return { ...item, id: index + 1 };
      })}
      setTags={setFactoryTags}
      ontologyData={ontologyData}
      isEdit={isEdit}
      closeModal={closeModal}
      onSave={onSave}
      uiSchema={factoryUISchema}
      dataSchema={factorySchema}
      metaDataSchema={factoryMetaDataSchema}
      isFrom='factory'
      editOntoData={editOntoData}
      pageData={pageData}
      factoryLabel={factoryLabel}
      showGatewayFilePicker={!isEdit}
      gatewayOptions={(gateways || [])
        .filter((gateway: any) => gateway.data_transfer_status === 'provisioned')
        .map((gateway: any) => ({
          value: String(gateway.gateway_id),
          label: gateway.gateway_name,
        }))}
      selectedGatewayId={selectedImportGatewayId}
      onGatewayChange={setSelectedImportGatewayId}
      selectedImportFile={selectedImportFile}
      onImportFileChange={setSelectedImportFile}
    />
  );

  const columns = [
    {
      field: 'factory_name',
      headerName: `${get(pageData, 'entity_name', ontologyData?.slice(-1)?.[0]?.level_name ?? 'Shop floor') + ' Name'}`,
      resizable: false,
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 200,
      renderCell: (params: GridValueGetterParams) => {
        return (
          <Tooltip title={params.value} placement='bottom' arrow>
            <Typography
              component='span'
              color='primary'
              sx={Styles.displayName}
              onClick={() => onClickFactoryName(params.row)}
            >
              {params.value}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'no_of_egs',
      headerName: 'NO. OF EGS',
      headerAlign: 'center',
      resizable: false,
      align: 'center',
      flex: 1,
      minWidth: 140,
    },
    {
      field: 'no_of_assets',
      headerName: 'NO. OF ASSETS',
      headerAlign: 'center',
      resizable: false,
      align: 'center',
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'no_of_machines',
      headerName: `NO. OF ${get(pageData, 'machine_name', 'MACHINE') + 's'}`,
      headerAlign: 'center',
      resizable: false,
      align: 'center',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'status',
      headerName: 'STATUS',
      headerAlign: 'left',
      align: 'left',
      resizable: false,
      flex: 1,
      minWidth: 180,
      renderCell: (params: GridValueGetterParams) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip
              label={sentenceCase(params.value ?? '')}
              key={params.id}
              className={params.value}
              variant='outlined'
              sx={{ padding: '0px 8px 0px 8px!important', minWidth: '200px' }}
            />
            {
              ['uninstallation_failed', 'deployment_failed'].includes(params.value) && (
                <Tooltip title={sentenceCase(params.row.status_info ?? '')} placement='top' arrow>
                  <InfoIcon style={{ color: palette.secondary.dark }} />
                </Tooltip>
              )
            }
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <MasterComponent
        heading={
          <Tabs value={selectedTab} onChange={onTabChange} TabIndicatorProps={{
            style: {
              backgroundColor: themeData.palette.primary.main,
            },
          }} >
            <Tab label={`List of ${pluralize(factoryLabel)}`} />
            <Tab label='Pending Approvals' />
          </Tabs>
        }
        isFromUseCase
        selectedTab={selectedTab}
        hiddenColumns={hiddenColumns}
        onStatusChange={onStatusChange}
        isLoading={isFactoriesListLoading}
        checkboxSelection
        onRowSelectionChange={handleRowSelection}
        rows={factoryManagementData}
        columns={columns}
        isServerPagination
        totalRowCount={factoriesListTotalRowCount}
        pageNumber={factoriesListPageNumber}
        onPagination={(pageSize: number, pageNumber: number) => {
          dispatchFactoriesListRequest({
            limit: pageSize,
            page: pageNumber,
            filter_status: filterStatus,
          });
        }}
        onSorting={(sortModel: { field: string; sort: string }) => {
          dispatchFactoriesListRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: factoriesListPageNumber,
            filter_status: filterStatus,
            ...sortModel,
          });
          setSortingModel(sortModel);
        }}
        setIsModalOpen={onModalOpen}
        disableRowSelectionOnClick
        selectionModel={selectedRows}
        isRowSelectable={isRowSelectable}
        otherProps={{
          getRowId: (row: any) => row.factory_id,
        }}
        noRowsOverlay={() => (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            {factoryLabel} data not available
          </Stack>
        )}
        actionsColumn={{
          visible: {
            onClick: (params: GridValueGetterParams) => {
              // const factoryName = params.row.factory_name.split(' ').join('-').toLowerCase();
              navigate(`${params.row.factory_id}/live`, { state: { ...params.row, from: 'factory' } });
            },
          },
          edit: {
            onClick: (params: GridValueGetterParams) => handleEdit(params.row),
          },
          delete: {
            onClick: (params: GridValueGetterParams) => {
              setDeletableFactory(get(params, 'row', {}));
              setAlertPopup({ isOpen: true, type: 'delete' });
            },
          },
        }}
        showSearch
        searchPlaceholder={factoryLabel + ' Name / Status'}
        onSearch={(searchValue: string) => {
          dispatchFactoriesListRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
            filter_status: filterStatus,
            search_item: searchValue,
          });
          dispatch(factoryManagementActions.onSearchForItem(searchValue));
        }}
        showDownloadTemplate
        onDownloadTemplate={onDownloadTemplate}
      />
      {isModalOpen && renderFormModal()}
      {get(alertPopup, 'isOpen', false) && renderAlertPopup()}
      <FactoryDownloadTemplateModal
        open={isDownloadTemplateModalOpen}
        components={componentMasterData}
        selectedComponents={selectedTemplateComponents}
        onComponentToggle={onTemplateComponentToggle}
        onClose={onCloseDownloadTemplateModal}
        onDownload={onDownloadTemplateConfirm}
      />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  ontologyData: state.ontologyMaster.ontologyData,
  ontologyMgmntData: state.ontologyMaster.ontologyMgmntData,
  factoriesList: state.factoryManagement.factoriesList,
  factoriesListTotalRowCount: state.factoryManagement.factoriesListTotalRowCount,
  factoriesListPageNumber: state.factoryManagement.factoriesListPageNumber,
  isFactoriesListLoading: state.factoryManagement.isFactoriesListLoading,
  isAddFactorySuccess: state.factoryManagement.isAddFactorySuccess,
  isUpdateFactorySuccess: state.factoryManagement.isUpdateFactorySuccess,
  isRemoveFactorySuccess: state.factoryManagement.isRemoveFactorySuccess,
  isUpdateFactoryStatusSuccess: state.factoryManagement.isUpdateFactoryStatusSuccess,
  isupdateFactoryStatusError: state.factoryManagement.isupdateFactoryStatusError,
  approver: state.factoryManagement.approver,
  searchItem: state.factoryManagement.searchItem,
  settingsData: state.settings.settingsData,
  componentMasterData: state.componentMaster.componentMasterData,
  gateways: state.gatewayMaster.gatewayMasterData,
  secretsData: state.secretsManager.secretsData,
});

export default connect(mapStateToProps)(FactoryList);
